/** Иконки отбора (хэндофф): 24×24, stroke 1.9, round, fill:none. */

type IconProps = { size?: number; className?: string };

function make(path: string) {
  return function Icon({ size = 24, className }: IconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.9}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
      >
        <path d={path} />
      </svg>
    );
  };
}

export const TicketIcon = make(
  'M3.5 7.5A1.5 1.5 0 0 1 5 6h14a1.5 1.5 0 0 1 1.5 1.5v2.2a2.3 2.3 0 0 0 0 4.6v2.2A1.5 1.5 0 0 1 19 18H5a1.5 1.5 0 0 1-1.5-1.5v-2.2a2.3 2.3 0 0 0 0-4.6zM14.5 6.5v2M14.5 11v2M14.5 15.5v2',
);
export const ZoneIcon = make('M5.5 21V4M5.5 4h11.5l-2.4 3.6 2.4 3.6H5.5');
export const StarIcon = make(
  'M12 3.5l2.5 5.3 5.8.7-4.3 4 1.1 5.7L12 16.4l-5.1 2.8 1.1-5.7-4.3-4 5.8-.7z',
);
export const CalibIcon = make('M4 16.5a8 8 0 0 1 16 0M12 16.5l3.6-4.6M7.5 16.5h0M16.5 16.5h0');
export const WarnIcon = make('M12 4.2l8.6 15H3.4zM12 10v4.2M12 16.9h0');
export const DecayIcon = make('M4 7l6 6 3.5-3.5L20 16M20 11v5h-5');
export const FloorIcon = make('M4 19h16M12 4.5v9.5M8.3 10.3L12 14l3.7-3.7');
export const VsIcon = make('M4 5l7 7-7 7M20 5l-7 7 7 7');
export const InfoIcon = make('M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v5M12 7.6h0');
